import React from 'react';
import styled, { css } from 'styled-components';

export const Flex = styled.div`
  display: flex;
  flex-direction: ${({ direction }) => direction || 'column'};
`;
